
// import React, { useState, useEffect, useCallback, useMemo, useRef } from 'react';
// import { useGoogleAuth } from '../Pages/Calendar/googleClient';

// /* ------------------------------------------------------------------ */
// /*  Constants                                                          */
// /* ------------------------------------------------------------------ */

// const FOLDER_MIME = 'application/vnd.google-apps.folder';
// const CRM_ROOT_NAME = 'CRM Documents';
// const DRIVE_ROOT = { id: 'root', name: 'My Drive' };

// const TABS = [
//   { id: 'crm', label: 'CRM Documents', hint: 'Managed workspace' },
//   { id: 'drive', label: 'Browse My Drive', hint: 'Everything you own' },
// ];

// /* ------------------------------------------------------------------ */
// /*  Helpers                                                             */
// /* ------------------------------------------------------------------ */

// function formatBytes(bytes) {
//   const n = Number(bytes);
//   if (!n) return '—';
//   const units = ['B', 'KB', 'MB', 'GB'];
//   let i = 0;
//   let value = n;
//   while (value >= 1024 && i < units.length - 1) {
//     value /= 1024;
//     i += 1;
//   }
//   return `${value.toFixed(value < 10 && i > 0 ? 1 : 0)} ${units[i]}`;
// }

// function formatDate(iso) {
//   if (!iso) return '—';
//   return new Date(iso).toLocaleDateString(undefined, {
//     day: 'numeric',
//     month: 'short',
//     year: 'numeric',
//   });
// }

// function getFileKind(mimeType = '') {
//   if (mimeType === FOLDER_MIME) return 'folder';
//   if (mimeType.startsWith('image/')) return 'image';
//   if (mimeType === 'application/pdf') return 'pdf';
//   if (mimeType.includes('spreadsheet') || mimeType === 'text/csv') return 'sheet';
//   if (mimeType.includes('presentation')) return 'slide';
//   if (mimeType.includes('document') || mimeType === 'text/plain') return 'doc';
//   return 'file';
// }

// const KIND_STYLE = {
//   folder: { bg: '#EFF3FA', fg: '#2C4A78' },
//   image: { bg: '#F1EAFB', fg: '#6B3FA0' },
//   pdf: { bg: '#FBEAE6', fg: '#C4432E' },
//   sheet: { bg: '#E6F6EF', fg: '#1F9D6B' },
//   slide: { bg: '#FDF0E1', fg: '#B8721E' },
//   doc: { bg: '#EAF1FB', fg: '#2563A8' },
//   file: { bg: '#F0F1F4', fg: '#5B6478' },
// };

// /* ------------------------------------------------------------------ */
// /*  Icons                                                              */
// /* ------------------------------------------------------------------ */

// const iconProps = { width: 18, height: 18, viewBox: '0 0 24 24', fill: 'none', stroke: 'currentColor', strokeWidth: 1.8, strokeLinecap: 'round', strokeLinejoin: 'round' };

// const Icon = {
//   Folder: (p) => <svg {...iconProps} {...p}><path d="M3 7a2 2 0 0 1 2-2h4l2 2h8a2 2 0 0 1 2 2v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V7Z" /></svg>,
//   File: (p) => <svg {...iconProps} {...p}><path d="M6 3h8l5 5v12a1 1 0 0 1-1 1H6a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1Z" /><path d="M14 3v5h5" /></svg>,
//   Image: (p) => <svg {...iconProps} {...p}><rect x="3.5" y="4.5" width="17" height="15" rx="2" /><circle cx="9" cy="10" r="1.6" /><path d="m5 17 4.5-4.5a2 2 0 0 1 2.8 0L20 20.5" /></svg>,
//   Pdf: (p) => <svg {...iconProps} {...p}><path d="M6 3h8l5 5v12a1 1 0 0 1-1 1H6a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1Z" /><path d="M14 3v5h5" /><path d="M8 17v-4h1.4a1.3 1.3 0 1 1 0 2.6H8M13 17v-4h1.6a1.4 1.4 0 0 1 0 4H13Z" /></svg>,
//   Sheet: (p) => <svg {...iconProps} {...p}><rect x="4" y="4" width="16" height="16" rx="2" /><path d="M4 9.5h16M4 14.5h16M10 4v16" /></svg>,
//   Slide: (p) => <svg {...iconProps} {...p}><rect x="3" y="4.5" width="18" height="12" rx="1.5" /><path d="M8 20h8M12 16.5V20" /></svg>,
//   Search: (p) => <svg {...iconProps} {...p}><circle cx="11" cy="11" r="6.5" /><path d="m20 20-3.6-3.6" /></svg>,
//   Plus: (p) => <svg {...iconProps} {...p}><path d="M12 5v14M5 12h14" /></svg>,
//   Upload: (p) => <svg {...iconProps} {...p}><path d="M12 16V4M7 9l5-5 5 5" /><path d="M4 17v2a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-2" /></svg>,
//   UploadCloud: (p) => <svg {...iconProps} {...p}><path d="M7 18a4.5 4.5 0 0 1-.9-8.9 5.5 5.5 0 0 1 10.6-2A4.5 4.5 0 0 1 17 18H7Z" /><path d="M12 12v7M9.5 14.5 12 12l2.5 2.5" /></svg>,
//   Download: (p) => <svg {...iconProps} {...p}><path d="M12 4v12M7 11l5 5 5-5" /><path d="M4 17v2a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-2" /></svg>,
//   ExternalLink: (p) => <svg {...iconProps} {...p}><path d="M14 4h6v6" /><path d="M10 14 20 4" /><path d="M18 13v5a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h5" /></svg>,
//   Chevron: (p) => <svg {...iconProps} {...p}><path d="m9 6 6 6-6 6" /></svg>,
//   Home: (p) => <svg {...iconProps} {...p}><path d="m4 11 8-7 8 7" /><path d="M6 10v9a1 1 0 0 0 1 1h3v-6h4v6h3a1 1 0 0 0 1-1v-9" /></svg>,
//   Google: (p) => <svg width={18} height={18} viewBox="0 0 24 24" {...p}><path fill="#4285F4" d="M23.5 12.3c0-.85-.08-1.66-.22-2.44H12v4.62h6.47a5.53 5.53 0 0 1-2.4 3.63v3h3.88c2.27-2.09 3.55-5.17 3.55-8.81Z" /><path fill="#34A853" d="M12 24c3.24 0 5.96-1.07 7.95-2.9l-3.88-3c-1.08.73-2.46 1.15-4.07 1.15-3.13 0-5.78-2.11-6.73-4.96H1.26v3.1A12 12 0 0 0 12 24Z" /><path fill="#FBBC05" d="M5.27 14.29a7.2 7.2 0 0 1 0-4.58v-3.1H1.26a12 12 0 0 0 0 10.78l4.01-3.1Z" /><path fill="#EA4335" d="M12 4.75c1.77 0 3.35.61 4.6 1.8l3.42-3.42C17.95 1.19 15.24 0 12 0A12 12 0 0 0 1.26 6.61l4.01 3.1C6.22 6.86 8.87 4.75 12 4.75Z" /></svg>,
//   Refresh: (p) => <svg {...iconProps} {...p}><path d="M4 4v6h6" /><path d="M20 20v-6h-6" /><path d="M20 10a8 8 0 0 0-14.6-4.6M4 14a8 8 0 0 0 14.6 4.6" /></svg>,
//   X: (p) => <svg {...iconProps} {...p}><path d="M6 6l12 12M18 6 6 18" /></svg>,
//   Drive: (p) => <svg {...iconProps} {...p}><path d="M8 3h8l6 10.5-4 7H6l-4-7L8 3Z" /><path d="M8 3 2 13.5h12" /></svg>,
//   Edit: (p) => <svg {...iconProps} {...p}><path d="M15 3l6 6M9 21H3v-6L16 2l6 6L9 21z" /></svg>,
//   Trash: (p) => <svg {...iconProps} {...p}><path d="M4 6h16M9 6V4a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v2" /><path d="M5 6v13a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V6" /></svg>,
// };

// function FileTypeIcon({ mimeType, size = 20 }) {
//   const kind = getFileKind(mimeType);
//   const { bg, fg } = KIND_STYLE[kind];
//   const Cmp = { folder: Icon.Folder, image: Icon.Image, pdf: Icon.Pdf, sheet: Icon.Sheet, slide: Icon.Slide, doc: Icon.File, file: Icon.File }[kind];
//   return (
//     <span className="dm-type-icon" style={{ background: bg, color: fg }}>
//       <Cmp width={size} height={size} />
//     </span>
//   );
// }

// /* ------------------------------------------------------------------ */
// /*  Component                                                          */
// /* ------------------------------------------------------------------ */

// const DocumentManager = () => {
//   const { accessToken, userEmail, gisReady, authError, connect, disconnect } = useGoogleAuth();

//   const [activeTab, setActiveTab] = useState('crm');
//   const [folderPath, setFolderPath] = useState([]);
//   const [folders, setFolders] = useState([]);
//   const [files, setFiles] = useState([]);
//   const [loadingItems, setLoadingItems] = useState(false);
//   const [itemsError, setItemsError] = useState('');
//   const [searchQuery, setSearchQuery] = useState('');
//   const [lastRefreshed, setLastRefreshed] = useState(null);

//   const [newFolderName, setNewFolderName] = useState('');
//   const [creatingFolder, setCreatingFolder] = useState(false);
//   const [showNewFolderInput, setShowNewFolderInput] = useState(false);

//   const [selectedFile, setSelectedFile] = useState(null);
//   const [uploading, setUploading] = useState(false);
//   const [uploadError, setUploadError] = useState('');
//   const [isDragging, setIsDragging] = useState(false);
//   const fileInputRef = useRef(null);
//   const dragCounter = useRef(0);

//   const currentFolder = folderPath[folderPath.length - 1] || null;
//   const rootFolderId = folderPath[0]?.id || null;

//   /* ---- resolve / create the CRM Documents root folder ---- */
//   const ensureCrmRoot = useCallback(async () => {
//     const q = encodeURIComponent(
//       `name = '${CRM_ROOT_NAME}' and mimeType = '${FOLDER_MIME}' and trashed = false`
//     );
//     const res = await fetch(
//       `https://www.googleapis.com/drive/v3/files?q=${q}&fields=files(id,name)`,
//       { headers: { Authorization: `Bearer ${accessToken}` } }
//     );
//     const data = await res.json();
//     if (data.files && data.files.length > 0) return data.files[0];

//     const createRes = await fetch('https://www.googleapis.com/drive/v3/files', {
//       method: 'POST',
//       headers: { Authorization: `Bearer ${accessToken}`, 'Content-Type': 'application/json' },
//       body: JSON.stringify({ name: CRM_ROOT_NAME, mimeType: FOLDER_MIME }),
//     });
//     if (!createRes.ok) throw new Error('Could not create the CRM Documents folder.');
//     return createRes.json();
//   }, [accessToken]);

//   /* ---- set the root of the active tab whenever token / tab changes ---- */
//   useEffect(() => {
//     if (!accessToken) {
//       setFolderPath([]);
//       return;
//     }
//     setSearchQuery('');
//     if (activeTab === 'drive') {
//       setFolderPath([DRIVE_ROOT]);
//       return;
//     }
//     (async () => {
//       try {
//         const root = await ensureCrmRoot();
//         setFolderPath([{ id: root.id, name: root.name || CRM_ROOT_NAME }]);
//       } catch (err) {
//         setItemsError(err.message || 'Could not open CRM Documents.');
//       }
//     })();
//   }, [accessToken, activeTab, ensureCrmRoot]);

//   /* ---- load the contents of whichever folder is open ---- */
//   const loadFolderContents = useCallback(async (folderId) => {
//     if (!folderId || !accessToken) return;
//     setLoadingItems(true);
//     setItemsError('');
//     try {
//       const params = new URLSearchParams({
//         q: `'${folderId}' in parents and trashed = false`,
//         fields: 'files(id, name, mimeType, webViewLink, createdTime, size)',
//         orderBy: 'folder,name',
//         pageSize: '200',
//       });
//       const res = await fetch(`https://www.googleapis.com/drive/v3/files?${params}`, {
//         headers: { Authorization: `Bearer ${accessToken}` },
//       });
//       const data = await res.json();
//       if (!res.ok) throw new Error(data.error?.message || 'Could not load this folder.');

//       const all = data.files || [];
//       console.log('📂 Files in folder:', all); // Debug: see everything returned

//       setFolders(all.filter((f) => f.mimeType === FOLDER_MIME));
//       setFiles(all.filter((f) => f.mimeType !== FOLDER_MIME));
//       setLastRefreshed(new Date());
//     } catch (err) {
//       setItemsError(err.message);
//     } finally {
//       setLoadingItems(false);
//     }
//   }, [accessToken]);

//   // Load folder when current folder changes (initial load, navigation)
//   useEffect(() => {
//     if (currentFolder) loadFolderContents(currentFolder.id);
//   }, [currentFolder, loadFolderContents]);

//   /* ---- refresh when tab becomes visible (user returns to the tab) ---- */
//   useEffect(() => {
//     const handleVisibilityChange = () => {
//       if (!document.hidden && currentFolder) {
//         loadFolderContents(currentFolder.id);
//       }
//     };
//     document.addEventListener('visibilitychange', handleVisibilityChange);
//     return () => document.removeEventListener('visibilitychange', handleVisibilityChange);
//   }, [currentFolder, loadFolderContents]);

//   /* ---- manual refresh function ---- */
//   const refresh = () => currentFolder && loadFolderContents(currentFolder.id);

//   /* ---- navigation ---- */
//   const openFolder = (folder) => setFolderPath((prev) => [...prev, { id: folder.id, name: folder.name }]);
//   const goToBreadcrumb = (index) => setFolderPath((prev) => prev.slice(0, index + 1));

//   /* ---- create a sub-folder inside the folder that's open ---- */
//   const handleCreateFolder = async () => {
//     if (!newFolderName.trim() || !currentFolder) return;
//     setCreatingFolder(true);
//     setItemsError('');
//     try {
//       const res = await fetch('https://www.googleapis.com/drive/v3/files', {
//         method: 'POST',
//         headers: { Authorization: `Bearer ${accessToken}`, 'Content-Type': 'application/json' },
//         body: JSON.stringify({
//           name: newFolderName.trim(),
//           mimeType: FOLDER_MIME,
//           parents: [currentFolder.id],
//         }),
//       });
//       if (!res.ok) throw new Error('Could not create the folder.');
//       setNewFolderName('');
//       setShowNewFolderInput(false);
//       loadFolderContents(currentFolder.id);
//     } catch (err) {
//       setItemsError(err.message);
//     } finally {
//       setCreatingFolder(false);
//     }
//   };

//   /* ---- upload ---- */
//   const pickFile = (file) => {
//     if (!file) return;
//     setSelectedFile(file);
//     setUploadError('');
//   };

//   const handleFileChange = (e) => pickFile(e.target.files?.[0]);

//   const runUpload = async () => {
//     if (!selectedFile || !currentFolder) return;
//     setUploading(true);
//     setUploadError('');
//     try {
//       const metadata = { name: selectedFile.name, parents: [currentFolder.id] };
//       const form = new FormData();
//       form.append('metadata', new Blob([JSON.stringify(metadata)], { type: 'application/json' }));
//       form.append('file', selectedFile);

//       const res = await fetch(
//         'https://www.googleapis.com/upload/drive/v3/files?uploadType=multipart&fields=id,name,webViewLink,mimeType,createdTime',
//         { method: 'POST', headers: { Authorization: `Bearer ${accessToken}` }, body: form }
//       );
//       const data = await res.json();
//       if (!res.ok) throw new Error(data.error?.message || 'Upload failed.');

//       setSelectedFile(null);
//       if (fileInputRef.current) fileInputRef.current.value = '';
//       loadFolderContents(currentFolder.id);
//     } catch (err) {
//       setUploadError(err.message);
//     } finally {
//       setUploading(false);
//     }
//   };

//   /* ---- drag & drop ---- */
//   const onDragEnter = (e) => { e.preventDefault(); dragCounter.current += 1; setIsDragging(true); };
//   const onDragLeave = (e) => { e.preventDefault(); dragCounter.current -= 1; if (dragCounter.current <= 0) setIsDragging(false); };
//   const onDragOver = (e) => e.preventDefault();
//   const onDrop = (e) => {
//     e.preventDefault();
//     dragCounter.current = 0;
//     setIsDragging(false);
//     pickFile(e.dataTransfer.files?.[0]);
//   };

//   /* ---- download ---- */
//   const handleDownload = async (fileId, fileName) => {
//     try {
//       const res = await fetch(`https://www.googleapis.com/drive/v3/files/${fileId}?alt=media`, {
//         headers: { Authorization: `Bearer ${accessToken}` },
//       });
//       if (!res.ok) throw new Error('Download failed.');
//       const blob = await res.blob();
//       const url = window.URL.createObjectURL(blob);
//       const a = document.createElement('a');
//       a.href = url;
//       a.download = fileName;
//       document.body.appendChild(a);
//       a.click();
//       a.remove();
//       window.URL.revokeObjectURL(url);
//     } catch (err) {
//       setItemsError(`Download failed: ${err.message}`);
//     }
//   };

//   /* ---- delete ---- */
//   const handleDelete = async (fileId, fileName, isFolder = false) => {
//     if (!window.confirm(`Are you sure you want to delete "${fileName}"?`)) return;
//     try {
//       const res = await fetch(`https://www.googleapis.com/drive/v3/files/${fileId}`, {
//         method: 'DELETE',
//         headers: { Authorization: `Bearer ${accessToken}` },
//       });
//       if (!res.ok) throw new Error('Delete failed.');
//       if (currentFolder) loadFolderContents(currentFolder.id);
//     } catch (err) {
//       setItemsError(`Delete failed: ${err.message}`);
//     }
//   };

//   /* ---- rename ---- */
//   const handleRename = async (fileId, currentName) => {
//     const newName = window.prompt('Enter new name:', currentName);
//     if (!newName || newName === currentName) return;
//     try {
//       const res = await fetch(`https://www.googleapis.com/drive/v3/files/${fileId}`, {
//         method: 'PATCH',
//         headers: { Authorization: `Bearer ${accessToken}`, 'Content-Type': 'application/json' },
//         body: JSON.stringify({ name: newName.trim() }),
//       });
//       if (!res.ok) throw new Error('Rename failed.');
//       if (currentFolder) loadFolderContents(currentFolder.id);
//     } catch (err) {
//       setItemsError(`Rename failed: ${err.message}`);
//     }
//   };

//   const handleDisconnect = () => {
//     setActiveTab('crm');
//     setSearchQuery('');
//     disconnect();
//   };

//   /* ---- client-side filter ---- */
//   const filteredFolders = useMemo(
//     () => folders.filter((f) => f.name.toLowerCase().includes(searchQuery.trim().toLowerCase())),
//     [folders, searchQuery]
//   );
//   const filteredFiles = useMemo(
//     () => files.filter((f) => f.name.toLowerCase().includes(searchQuery.trim().toLowerCase())),
//     [files, searchQuery]
//   );
//   const isEmpty = !loadingItems && filteredFolders.length === 0 && filteredFiles.length === 0;
//   const totalCount = folders.length + files.length;

//   /* ------------------------------------------------------------------ */
//   /*  Render — signed out                                                 */
//   /* ------------------------------------------------------------------ */

//   if (!accessToken) {
//     return (
//       <div className="dm-page dm-page-center">
//         <GlobalStyles />
//         <div className="dm-signin-card">
//           <div className="dm-signin-icon"><Icon.Drive width={26} height={26} /></div>
//           <h1 className="dm-signin-title">Document Manager</h1>
//           <p className="dm-signin-copy">
//             Connect Google Drive to store, organize and share every file linked to your deals and
//             accounts — using the same login as Calendar.
//           </p>
//           {authError && <p className="dm-banner dm-banner-error">{authError}</p>}
//           <button className="dm-btn dm-btn-primary dm-btn-lg" onClick={connect} disabled={!gisReady}>
//             <Icon.Google />
//             {gisReady ? 'Connect Google Drive' : 'Loading…'}
//           </button>
//         </div>
//       </div>
//     );
//   }

//   /* ------------------------------------------------------------------ */
//   /*  Render — signed in                                                  */
//   /* ------------------------------------------------------------------ */

//   return (
//     <div className="dm-page">
//       <GlobalStyles />

//       {/* Page header */}
//       <header className="dm-page-header">
//         <div>
//           <h1 className="dm-page-title">Documents</h1>
//           <p className="dm-page-subtitle">Files linked to your leads, deals and accounts</p>
//         </div>
//         <div className="dm-account">
//           <span className="dm-account-dot" />
//           <span className="dm-account-email">{userEmail || 'Connected'}</span>
//           <button className="dm-link dm-link-danger" onClick={handleDisconnect}>Disconnect</button>
//         </div>
//       </header>

//       <div className="dm-layout">

//         {/* Sidebar */}
//         <aside className="dm-sidebar">
//           <nav className="dm-nav">
//             {TABS.map((tab) => (
//               <button
//                 key={tab.id}
//                 className={`dm-nav-item ${activeTab === tab.id ? 'dm-nav-item-active' : ''}`}
//                 onClick={() => setActiveTab(tab.id)}
//               >
//                 {tab.id === 'crm' ? <Icon.Folder width={17} height={17} /> : <Icon.Drive width={17} height={17} />}
//                 <span>
//                   <span className="dm-nav-item-label">{tab.label}</span>
//                   <span className="dm-nav-item-hint">{tab.hint}</span>
//                 </span>
//               </button>
//             ))}
//           </nav>

//           <div className="dm-sidebar-divider" />

//           <div className="dm-sidebar-label">Current location</div>
//           <div className="dm-path-trail">
//             {folderPath.map((f, i) => (
//               <button
//                 key={f.id}
//                 className={`dm-path-item ${i === folderPath.length - 1 ? 'dm-path-item-current' : ''}`}
//                 onClick={() => goToBreadcrumb(i)}
//                 disabled={i === folderPath.length - 1}
//                 style={{ paddingLeft: 10 + i * 14 }}
//               >
//                 {i === 0 ? <Icon.Home width={13} height={13} /> : <Icon.Chevron width={12} height={12} />}
//                 <span>{f.name}</span>
//               </button>
//             ))}
//           </div>

//           <div className="dm-sidebar-divider" />

//           <div className="dm-sidebar-stats">
//             <span>{totalCount} item{totalCount === 1 ? '' : 's'}</span>
//             <button className="dm-icon-btn" onClick={refresh} title="Refresh" disabled={loadingItems}>
//               <Icon.Refresh className={loadingItems ? 'dm-spin' : ''} width={15} height={15} />
//             </button>
//           </div>
//         </aside>

//         {/* Main content */}
//         <main
//           className="dm-main"
//           onDragEnter={onDragEnter}
//           onDragLeave={onDragLeave}
//           onDragOver={onDragOver}
//           onDrop={onDrop}
//         >
//           {isDragging && (
//             <div className="dm-drop-overlay">
//               <Icon.UploadCloud width={30} height={30} />
//               <p>Drop to upload into “{currentFolder?.name}”</p>
//             </div>
//           )}

//           {/* Toolbar */}
//           <div className="dm-toolbar">
//             <div className="dm-search">
//               <Icon.Search width={16} height={16} />
//               <input
//                 placeholder={`Search in "${currentFolder?.name || ''}"`}
//                 value={searchQuery}
//                 onChange={(e) => setSearchQuery(e.target.value)}
//               />
//             </div>

//             <div className="dm-toolbar-actions">
//               {/* Refresh button in toolbar */}
//               <button className="dm-icon-btn" onClick={refresh} title="Refresh now" disabled={loadingItems}>
//                 <Icon.Refresh className={loadingItems ? 'dm-spin' : ''} width={18} height={18} />
//               </button>

//               {showNewFolderInput ? (
//                 <div className="dm-new-folder">
//                   <input
//                     autoFocus
//                     placeholder="Folder name"
//                     value={newFolderName}
//                     onChange={(e) => setNewFolderName(e.target.value)}
//                     onKeyDown={(e) => e.key === 'Enter' && handleCreateFolder()}
//                   />
//                   <button className="dm-btn dm-btn-primary" onClick={handleCreateFolder} disabled={creatingFolder || !newFolderName.trim()}>
//                     {creatingFolder ? '…' : 'Create'}
//                   </button>
//                   <button className="dm-icon-btn" onClick={() => { setShowNewFolderInput(false); setNewFolderName(''); }}>
//                     <Icon.X width={16} height={16} />
//                   </button>
//                 </div>
//               ) : (
//                 <button className="dm-btn dm-btn-outline" onClick={() => setShowNewFolderInput(true)}>
//                   <Icon.Plus width={16} height={16} />
//                   New folder
//                 </button>
//               )}

//               <input ref={fileInputRef} type="file" onChange={handleFileChange} hidden />
//               <button className="dm-btn dm-btn-primary" onClick={() => fileInputRef.current?.click()}>
//                 <Icon.Upload width={16} height={16} />
//                 Upload
//               </button>
//             </div>
//           </div>

//           {/* Last refreshed timestamp */}
//           {lastRefreshed && (
//             <div className="dm-last-refreshed">
//               Last updated: {lastRefreshed.toLocaleTimeString()}
//             </div>
//           )}

//           {itemsError && <p className="dm-banner dm-banner-error">{itemsError}</p>}
//           {uploadError && <p className="dm-banner dm-banner-error">{uploadError}</p>}

//           {selectedFile && (
//             <div className="dm-pending-upload">
//               <FileTypeIcon mimeType={selectedFile.type} size={16} />
//               <div className="dm-row-main">
//                 <span className="dm-row-name">{selectedFile.name}</span>
//                 <span className="dm-row-meta">Uploads into “{currentFolder?.name || '…'}” · {formatBytes(selectedFile.size)}</span>
//               </div>
//               <button className="dm-btn dm-btn-primary" onClick={runUpload} disabled={uploading}>
//                 {uploading ? 'Uploading…' : 'Upload'}
//               </button>
//               <button
//                 className="dm-icon-btn"
//                 onClick={() => { setSelectedFile(null); if (fileInputRef.current) fileInputRef.current.value = ''; }}
//               >
//                 <Icon.X width={16} height={16} />
//               </button>
//             </div>
//           )}

//           {/* Listing */}
//           {loadingItems && (
//             <div className="dm-empty-state">
//               <div className="dm-spinner" />
//               <p>Loading…</p>
//             </div>
//           )}

//           {isEmpty && (
//             <div className="dm-empty-state">
//               <Icon.Folder width={30} height={30} />
//               <p>{searchQuery ? 'No matches in this folder.' : 'This folder is empty.'}</p>
//               {!searchQuery && (
//                 <p className="dm-empty-hint">Drag a file anywhere on this page, or use Upload above.</p>
//               )}
//             </div>
//           )}

//           {!loadingItems && (filteredFolders.length > 0 || filteredFiles.length > 0) && (
//             <div className="dm-grid">
//               {filteredFolders.map((f) => {
//                 const isRoot = f.id === rootFolderId;
//                 return (
//                   <div key={f.id} className="dm-card dm-card-folder" onClick={() => openFolder(f)}>
//                     <FileTypeIcon mimeType={f.mimeType} />
//                     <span className="dm-card-name">{f.name}</span>
//                     <Icon.Chevron width={15} height={15} className="dm-card-chevron" />
//                     <div className="dm-card-actions" onClick={(e) => e.stopPropagation()}>
//                       {!isRoot && (
//                         <>
//                           <button className="dm-icon-btn" onClick={() => handleRename(f.id, f.name)} title="Rename">
//                             <Icon.Edit width={15} height={15} />
//                           </button>
//                           <button className="dm-icon-btn" onClick={() => handleDelete(f.id, f.name, true)} title="Delete">
//                             <Icon.Trash width={15} height={15} />
//                           </button>
//                         </>
//                       )}
//                     </div>
//                   </div>
//                 );
//               })}
//               {filteredFiles.map((f) => (
//                 <div key={f.id} className="dm-card">
//                   <FileTypeIcon mimeType={f.mimeType} />
//                   <span className="dm-card-name">{f.name}</span>
//                   <span className="dm-card-meta">{formatBytes(f.size)} · {formatDate(f.createdTime)}</span>
//                   <div className="dm-card-actions">
//                     <a href={f.webViewLink} target="_blank" rel="noopener noreferrer" className="dm-icon-btn" title="Preview">
//                       <Icon.ExternalLink width={15} height={15} />
//                     </a>
//                     <button className="dm-icon-btn" onClick={() => handleDownload(f.id, f.name)} title="Download">
//                       <Icon.Download width={15} height={15} />
//                     </button>
//                     <button className="dm-icon-btn" onClick={() => handleRename(f.id, f.name)} title="Rename">
//                       <Icon.Edit width={15} height={15} />
//                     </button>
//                     <button className="dm-icon-btn" onClick={() => handleDelete(f.id, f.name)} title="Delete">
//                       <Icon.Trash width={15} height={15} />
//                     </button>
//                   </div>
//                 </div>
//               ))}
//             </div>
//           )}
//         </main>
//       </div>
//     </div>
//   );
// };

// /* ------------------------------------------------------------------ */
// /*  Styles                                                              */
// /* ------------------------------------------------------------------ */

// const GlobalStyles = () => (
//   <style>{`
//     .dm-page {
//       --dm-navy: #16233F;
//       --dm-navy-soft: #2C3B5C;
//       --dm-slate: #5B6478;
//       --dm-slate-light: #8890A0;
//       --dm-bg: #F6F7F9;
//       --dm-surface: #FFFFFF;
//       --dm-border: #E4E7EC;
//       --dm-primary: #1E3A5F;
//       --dm-primary-hover: #142845;
//       --dm-primary-soft: #EAF0F8;
//       --dm-gold: #A9761F;
//       --dm-gold-soft: #F7EFDE;
//       --dm-success: #1F9D6B;
//       --dm-danger: #C4432E;
//       --dm-danger-soft: #FBEAE6;
//       --dm-radius: 12px;
//       --dm-radius-sm: 8px;
//       font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;
//       color: var(--dm-navy);
//       width: 100%;
//       min-height: 100%;
//       box-sizing: border-box;
//       background: var(--dm-bg);
//       padding: 28px 36px 48px;
//     }
//     .dm-page * { box-sizing: border-box; }

//     .dm-page-center { display: flex; align-items: center; justify-content: center; min-height: 100vh; }

//     /* ---- sign-in state ---- */
//     .dm-signin-card {
//       text-align: center; padding: 44px 34px; max-width: 400px;
//       background: var(--dm-surface); border: 1px solid var(--dm-border);
//       border-radius: var(--dm-radius); box-shadow: 0 1px 2px rgba(22,35,63,0.05);
//     }
//     .dm-signin-icon {
//       width: 52px; height: 52px; border-radius: 12px;
//       background: var(--dm-primary-soft); color: var(--dm-primary);
//       display: flex; align-items: center; justify-content: center;
//       margin: 0 auto 16px;
//     }
//     .dm-signin-title {
//       font-family: 'Source Serif 4', Georgia, serif;
//       font-size: 22px; font-weight: 600; margin: 0 0 8px;
//     }
//     .dm-signin-copy {
//       color: var(--dm-slate); font-size: 14px; line-height: 1.6;
//       max-width: 360px; margin: 0 auto 22px;
//     }

//     /* ---- page header ---- */
//     .dm-page-header { display: flex; justify-content: space-between; align-items: flex-start; gap: 12px; flex-wrap: wrap; margin-bottom: 24px; }
//     .dm-page-title { font-family: 'Source Serif 4', Georgia, serif; font-size: 26px; font-weight: 600; margin: 0; }
//     .dm-page-subtitle { font-size: 13.5px; color: var(--dm-slate); margin: 4px 0 0; }
//     .dm-account { display: flex; align-items: center; gap: 8px; font-size: 13px; color: var(--dm-slate); margin-top: 4px; }
//     .dm-account-dot { width: 7px; height: 7px; border-radius: 50%; background: var(--dm-success); }
//     .dm-account-email { color: var(--dm-navy); font-weight: 500; }

//     .dm-link { background: none; border: none; cursor: pointer; padding: 0; font-size: 13px; font-family: inherit; }
//     .dm-link-danger { color: var(--dm-danger); }
//     .dm-link-danger:hover { text-decoration: underline; }

//     /* ---- layout ---- */
//     .dm-layout { display: grid; grid-template-columns: 240px 1fr; gap: 24px; align-items: start; }

//     /* ---- sidebar ---- */
//     .dm-sidebar {
//       background: var(--dm-surface); border: 1px solid var(--dm-border); border-radius: var(--dm-radius);
//       padding: 14px; position: sticky; top: 20px;
//     }
//     .dm-nav { display: flex; flex-direction: column; gap: 3px; }
//     .dm-nav-item {
//       display: flex; align-items: center; gap: 10px; text-align: left;
//       background: none; border: none; cursor: pointer; border-radius: var(--dm-radius-sm);
//       padding: 9px 10px; color: var(--dm-slate); font-family: inherit;
//     }
//     .dm-nav-item:hover { background: var(--dm-bg); color: var(--dm-navy); }
//     .dm-nav-item-active { background: var(--dm-primary-soft); color: var(--dm-primary); }
//     .dm-nav-item-label { display: block; font-size: 13.5px; font-weight: 600; }
//     .dm-nav-item-hint { display: block; font-size: 11.5px; opacity: 0.75; margin-top: 1px; }

//     .dm-sidebar-divider { height: 1px; background: var(--dm-border); margin: 12px 0; }
//     .dm-sidebar-label { font-size: 11px; font-weight: 600; text-transform: uppercase; letter-spacing: 0.04em; color: var(--dm-slate-light); padding: 0 10px 6px; }
//     .dm-path-trail { display: flex; flex-direction: column; gap: 1px; max-height: 220px; overflow-y: auto; }
//     .dm-path-item {
//       display: flex; align-items: center; gap: 6px; text-align: left;
//       background: none; border: none; cursor: pointer; border-radius: 6px;
//       padding: 6px 10px; font-size: 12.5px; color: var(--dm-primary); font-family: inherit;
//     }
//     .dm-path-item span { overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }
//     .dm-path-item:hover:not(:disabled) { background: var(--dm-bg); }
//     .dm-path-item-current { color: var(--dm-navy); font-weight: 600; cursor: default; }

//     .dm-sidebar-stats { display: flex; align-items: center; justify-content: space-between; padding: 0 6px; font-size: 12px; color: var(--dm-slate-light); }

//     /* ---- main ---- */
//     .dm-main { position: relative; min-width: 0; }

//     .dm-drop-overlay {
//       position: absolute; inset: 0; z-index: 5;
//       display: flex; flex-direction: column; align-items: center; justify-content: center; gap: 10px;
//       background: rgba(234,240,248,0.94); border: 2px dashed var(--dm-primary); border-radius: var(--dm-radius);
//       color: var(--dm-primary); font-size: 14px; font-weight: 500;
//     }

//     .dm-toolbar { display: flex; gap: 10px; flex-wrap: wrap; margin-bottom: 14px; }
//     .dm-search {
//       flex: 1; min-width: 200px; display: flex; align-items: center; gap: 8px;
//       border: 1px solid var(--dm-border); border-radius: var(--dm-radius-sm);
//       padding: 9px 12px; background: var(--dm-surface); color: var(--dm-slate-light);
//     }
//     .dm-search input { border: none; background: none; outline: none; font-size: 13.5px; color: var(--dm-navy); width: 100%; font-family: inherit; }
//     .dm-toolbar-actions { display: flex; gap: 8px; flex-wrap: wrap; align-items: center; }
//     .dm-new-folder { display: flex; gap: 6px; align-items: center; }
//     .dm-new-folder input {
//       border: 1px solid var(--dm-border); border-radius: var(--dm-radius-sm);
//       padding: 9px 12px; font-size: 13.5px; outline: none; font-family: inherit; width: 160px;
//     }
//     .dm-new-folder input:focus { border-color: var(--dm-primary); }

//     /* ---- last refreshed ---- */
//     .dm-last-refreshed {
//       font-size: 12px;
//       color: var(--dm-slate-light);
//       margin-bottom: 8px;
//       text-align: right;
//     }

//     /* ---- buttons ---- */
//     .dm-btn {
//       display: inline-flex; align-items: center; gap: 6px; justify-content: center;
//       font-size: 13.5px; font-weight: 500; font-family: inherit;
//       border-radius: var(--dm-radius-sm); padding: 9px 15px;
//       border: 1px solid transparent; cursor: pointer; transition: background .15s ease, border-color .15s ease;
//       white-space: nowrap;
//     }
//     .dm-btn:disabled { opacity: .55; cursor: not-allowed; }
//     .dm-btn-primary { background: var(--dm-primary); color: #fff; }
//     .dm-btn-primary:hover:not(:disabled) { background: var(--dm-primary-hover); }
//     .dm-btn-outline { background: var(--dm-surface); color: var(--dm-navy); border-color: var(--dm-border); }
//     .dm-btn-outline:hover:not(:disabled) { border-color: var(--dm-primary); color: var(--dm-primary); }
//     .dm-btn-lg { padding: 11px 22px; font-size: 14px; }

//     .dm-icon-btn {
//       display: inline-flex; align-items: center; justify-content: center;
//       width: 30px; height: 30px; border-radius: var(--dm-radius-sm);
//       background: none; border: 1px solid transparent; color: var(--dm-slate);
//       cursor: pointer; flex-shrink: 0; text-decoration: none;
//     }
//     .dm-icon-btn:hover { background: var(--dm-bg); color: var(--dm-navy); }

//     /* ---- banners ---- */
//     .dm-banner { font-size: 13px; padding: 9px 12px; border-radius: var(--dm-radius-sm); margin: 0 0 12px; }
//     .dm-banner-error { background: var(--dm-danger-soft); color: var(--dm-danger); }

//     /* ---- pending upload bar ---- */
//     .dm-pending-upload {
//       display: flex; align-items: center; gap: 12px;
//       border: 1px solid var(--dm-border); background: var(--dm-surface);
//       border-radius: var(--dm-radius); padding: 10px 12px; margin-bottom: 16px;
//     }

//     /* ---- type icon ---- */
//     .dm-type-icon {
//       display: inline-flex; align-items: center; justify-content: center;
//       width: 36px; height: 36px; border-radius: 8px; flex-shrink: 0;
//     }

//     /* ---- grid of cards ---- */
//     .dm-grid {
//       display: grid; grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));
//       gap: 10px;
//     }
//     .dm-card {
//       position: relative; display: flex; flex-direction: column; gap: 8px;
//       background: var(--dm-surface); border: 1px solid var(--dm-border); border-radius: var(--dm-radius);
//       padding: 14px; text-align: left; font-family: inherit; cursor: default;
//       transition: border-color .12s ease, box-shadow .12s ease;
//     }
//     .dm-card:hover { border-color: #D3D8E1; box-shadow: 0 2px 8px rgba(22,35,63,0.06); }
//     .dm-card-folder { cursor: pointer; }
//     .dm-card-name { font-size: 13.5px; font-weight: 500; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }
//     .dm-card-meta { font-size: 12px; color: var(--dm-slate-light); margin-top: -4px; }
//     .dm-card-chevron { position: absolute; top: 14px; right: 12px; color: var(--dm-slate-light); }
//     .dm-card-actions { display: flex; gap: 4px; margin-top: 2px; }

//     .dm-row-main { display: flex; flex-direction: column; min-width: 0; flex: 1; gap: 1px; }
//     .dm-row-name { font-size: 13.5px; font-weight: 500; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }
//     .dm-row-meta { font-size: 12px; color: var(--dm-slate-light); }

//     /* ---- empty / loading ---- */
//     .dm-empty-state {
//       display: flex; flex-direction: column; align-items: center; gap: 8px;
//       padding: 64px 0; color: var(--dm-slate-light); font-size: 13.5px;
//       background: var(--dm-surface); border: 1px dashed var(--dm-border); border-radius: var(--dm-radius);
//     }
//     .dm-empty-hint { font-size: 12px; }
//     .dm-spinner {
//       width: 20px; height: 20px; border-radius: 50%;
//       border: 2px solid var(--dm-border); border-top-color: var(--dm-primary);
//       animation: dm-rotate .7s linear infinite;
//     }
//     .dm-spin { animation: dm-rotate .7s linear infinite; }
//     @keyframes dm-rotate { to { transform: rotate(360deg); } }

//     @media (max-width: 860px) {
//       .dm-layout { grid-template-columns: 1fr; }
//       .dm-sidebar { position: static; }
//       .dm-path-trail { max-height: none; }
//     }
//     @media (max-width: 520px) {
//       .dm-page { padding: 20px 16px 36px; }
//       .dm-toolbar { flex-direction: column; align-items: stretch; }
//       .dm-new-folder input { width: auto; flex: 1; }
//     }
//   `}</style>
// );

// export default DocumentManager;

import React, { useState, useEffect, useCallback, useMemo, useRef } from 'react';
import { useGoogleAuth } from '../Pages/Calendar/googleClient';

/* ------------------------------------------------------------------ */
/*  Constants                                                          */
/* ------------------------------------------------------------------ */

const FOLDER_MIME = 'application/vnd.google-apps.folder';
const CRM_ROOT_NAME = 'PugCRM';
const DRIVE_ROOT = { id: 'root', name: 'My Drive' };

const TABS = [
  { id: 'crm', label: 'PugCRM', hint: 'Managed workspace' },
  { id: 'drive', label: 'Browse My Drive', hint: 'Everything you own' },
];

/* ------------------------------------------------------------------ */
/*  Helpers                                                             */
/* ------------------------------------------------------------------ */

function formatBytes(bytes) {
  const n = Number(bytes);
  if (!n) return '—';
  const units = ['B', 'KB', 'MB', 'GB'];
  let i = 0;
  let value = n;
  while (value >= 1024 && i < units.length - 1) {
    value /= 1024;
    i += 1;
  }
  return `${value.toFixed(value < 10 && i > 0 ? 1 : 0)} ${units[i]}`;
}

function formatDate(iso) {
  if (!iso) return '—';
  return new Date(iso).toLocaleDateString(undefined, {
    day: 'numeric',
    month: 'short',
    year: 'numeric',
  });
}

function getFileKind(mimeType = '') {
  if (mimeType === FOLDER_MIME) return 'folder';
  if (mimeType.startsWith('image/')) return 'image';
  if (mimeType === 'application/pdf') return 'pdf';
  if (mimeType.includes('spreadsheet') || mimeType === 'text/csv') return 'sheet';
  if (mimeType.includes('presentation')) return 'slide';
  if (mimeType.includes('document') || mimeType === 'text/plain') return 'doc';
  return 'file';
}

const KIND_STYLE = {
  folder: { bg: '#EFF3FA', fg: '#2C4A78' },
  image: { bg: '#F1EAFB', fg: '#6B3FA0' },
  pdf: { bg: '#FBEAE6', fg: '#C4432E' },
  sheet: { bg: '#E6F6EF', fg: '#1F9D6B' },
  slide: { bg: '#FDF0E1', fg: '#B8721E' },
  doc: { bg: '#EAF1FB', fg: '#2563A8' },
  file: { bg: '#F0F1F4', fg: '#5B6478' },
};

/* ------------------------------------------------------------------ */
/*  Icons — small inline SVGs, single stroke family                    */
/* ------------------------------------------------------------------ */

const iconProps = { width: 18, height: 18, viewBox: '0 0 24 24', fill: 'none', stroke: 'currentColor', strokeWidth: 1.8, strokeLinecap: 'round', strokeLinejoin: 'round' };

const Icon = {
  Folder: (p) => <svg {...iconProps} {...p}><path d="M3 7a2 2 0 0 1 2-2h4l2 2h8a2 2 0 0 1 2 2v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V7Z" /></svg>,
  File: (p) => <svg {...iconProps} {...p}><path d="M6 3h8l5 5v12a1 1 0 0 1-1 1H6a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1Z" /><path d="M14 3v5h5" /></svg>,
  Image: (p) => <svg {...iconProps} {...p}><rect x="3.5" y="4.5" width="17" height="15" rx="2" /><circle cx="9" cy="10" r="1.6" /><path d="m5 17 4.5-4.5a2 2 0 0 1 2.8 0L20 20.5" /></svg>,
  Pdf: (p) => <svg {...iconProps} {...p}><path d="M6 3h8l5 5v12a1 1 0 0 1-1 1H6a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1Z" /><path d="M14 3v5h5" /><path d="M8 17v-4h1.4a1.3 1.3 0 1 1 0 2.6H8M13 17v-4h1.6a1.4 1.4 0 0 1 0 4H13Z" /></svg>,
  Sheet: (p) => <svg {...iconProps} {...p}><rect x="4" y="4" width="16" height="16" rx="2" /><path d="M4 9.5h16M4 14.5h16M10 4v16" /></svg>,
  Slide: (p) => <svg {...iconProps} {...p}><rect x="3" y="4.5" width="18" height="12" rx="1.5" /><path d="M8 20h8M12 16.5V20" /></svg>,
  Search: (p) => <svg {...iconProps} {...p}><circle cx="11" cy="11" r="6.5" /><path d="m20 20-3.6-3.6" /></svg>,
  Plus: (p) => <svg {...iconProps} {...p}><path d="M12 5v14M5 12h14" /></svg>,
  Upload: (p) => <svg {...iconProps} {...p}><path d="M12 16V4M7 9l5-5 5 5" /><path d="M4 17v2a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-2" /></svg>,
  UploadCloud: (p) => <svg {...iconProps} {...p}><path d="M7 18a4.5 4.5 0 0 1-.9-8.9 5.5 5.5 0 0 1 10.6-2A4.5 4.5 0 0 1 17 18H7Z" /><path d="M12 12v7M9.5 14.5 12 12l2.5 2.5" /></svg>,
  Download: (p) => <svg {...iconProps} {...p}><path d="M12 4v12M7 11l5 5 5-5" /><path d="M4 17v2a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-2" /></svg>,
  ExternalLink: (p) => <svg {...iconProps} {...p}><path d="M14 4h6v6" /><path d="M10 14 20 4" /><path d="M18 13v5a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h5" /></svg>,
  Chevron: (p) => <svg {...iconProps} {...p}><path d="m9 6 6 6-6 6" /></svg>,
  Home: (p) => <svg {...iconProps} {...p}><path d="m4 11 8-7 8 7" /><path d="M6 10v9a1 1 0 0 0 1 1h3v-6h4v6h3a1 1 0 0 0 1-1v-9" /></svg>,
  Google: (p) => <svg width={18} height={18} viewBox="0 0 24 24" {...p}><path fill="#4285F4" d="M23.5 12.3c0-.85-.08-1.66-.22-2.44H12v4.62h6.47a5.53 5.53 0 0 1-2.4 3.63v3h3.88c2.27-2.09 3.55-5.17 3.55-8.81Z" /><path fill="#34A853" d="M12 24c3.24 0 5.96-1.07 7.95-2.9l-3.88-3c-1.08.73-2.46 1.15-4.07 1.15-3.13 0-5.78-2.11-6.73-4.96H1.26v3.1A12 12 0 0 0 12 24Z" /><path fill="#FBBC05" d="M5.27 14.29a7.2 7.2 0 0 1 0-4.58v-3.1H1.26a12 12 0 0 0 0 10.78l4.01-3.1Z" /><path fill="#EA4335" d="M12 4.75c1.77 0 3.35.61 4.6 1.8l3.42-3.42C17.95 1.19 15.24 0 12 0A12 12 0 0 0 1.26 6.61l4.01 3.1C6.22 6.86 8.87 4.75 12 4.75Z" /></svg>,
  Refresh: (p) => <svg {...iconProps} {...p}><path d="M4 4v6h6" /><path d="M20 20v-6h-6" /><path d="M20 10a8 8 0 0 0-14.6-4.6M4 14a8 8 0 0 0 14.6 4.6" /></svg>,
  X: (p) => <svg {...iconProps} {...p}><path d="M6 6l12 12M18 6 6 18" /></svg>,
  Drive: (p) => <svg {...iconProps} {...p}><path d="M8 3h8l6 10.5-4 7H6l-4-7L8 3Z" /><path d="M8 3 2 13.5h12" /></svg>,
  Trash: (p) => <svg {...iconProps} {...p}><path d="M4 7h16" /><path d="M9 7V4a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v3" /><path d="M6 7l1 13a2 2 0 0 0 2 2h6a2 2 0 0 0 2-2l1-13" /><path d="M10 11v6M14 11v6" /></svg>,
  Edit: (p) => <svg {...iconProps} {...p}><path d="M12 20h9" /><path d="M16.5 3.5a2.12 2.12 0 0 1 3 3L7 19l-4 1 1-4Z" /></svg>,
  Check: (p) => <svg {...iconProps} {...p}><path d="M5 13l4 4L19 7" /></svg>,
};

function FileTypeIcon({ mimeType, size = 20 }) {
  const kind = getFileKind(mimeType);
  const { bg, fg } = KIND_STYLE[kind];
  const Cmp = { folder: Icon.Folder, image: Icon.Image, pdf: Icon.Pdf, sheet: Icon.Sheet, slide: Icon.Slide, doc: Icon.File, file: Icon.File }[kind];
  return (
    <span className="dm-type-icon" style={{ background: bg, color: fg }}>
      <Cmp width={size} height={size} />
    </span>
  );
}



const DocumentManager = () => {
  const { accessToken, userEmail, gisReady, authError, connect, disconnect } = useGoogleAuth();
  const [activeTab, setActiveTab] = useState('crm');
  const [folderPath, setFolderPath] = useState([]);
  const [folders, setFolders] = useState([]);
  const [files, setFiles] = useState([]);
  const [loadingItems, setLoadingItems] = useState(false);
  const [itemsError, setItemsError] = useState('');
  const [searchQuery, setSearchQuery] = useState('');
  const [newFolderName, setNewFolderName] = useState('');
  const [creatingFolder, setCreatingFolder] = useState(false);
  const [showNewFolderInput, setShowNewFolderInput] = useState(false);
  const [selectedFile, setSelectedFile] = useState(null);
  const [uploading, setUploading] = useState(false);
  const [uploadError, setUploadError] = useState('');
  const [isDragging, setIsDragging] = useState(false);
  const fileInputRef = useRef(null);
  const dragCounter = useRef(0);
  const [crmRootId, setCrmRootId] = useState(null);
  const [renamingId, setRenamingId] = useState(null);
  const [renameValue, setRenameValue] = useState('');
  const [renaming, setRenaming] = useState(false);
  const [deleteTarget, setDeleteTarget] = useState(null); 
  const [deleting, setDeleting] = useState(false);
  const currentFolder = folderPath[folderPath.length - 1] || null;
  const ensureCrmRoot = useCallback(async () => {
    const q = encodeURIComponent(
      `name = '${CRM_ROOT_NAME}' and mimeType = '${FOLDER_MIME}' and trashed = false`
    );
    const res = await fetch(
      `https://www.googleapis.com/drive/v3/files?q=${q}&fields=files(id,name)`,
      { headers: { Authorization: `Bearer ${accessToken}` } }
    );
    const data = await res.json();
    if (data.files && data.files.length > 0) return data.files[0];
    const createRes = await fetch('https://www.googleapis.com/drive/v3/files', {
      method: 'POST',
      headers: { Authorization: `Bearer ${accessToken}`, 'Content-Type': 'application/json' },
      body: JSON.stringify({ name: CRM_ROOT_NAME, mimeType: FOLDER_MIME }),
    });
    if (!createRes.ok) throw new Error('Could not create the PugCRM folder.');
    return createRes.json();
  }, [accessToken]);
  useEffect(() => {
    if (!accessToken) {
      setFolderPath([]);
      setCrmRootId(null);
      return;
    }
    setSearchQuery('');
    (async () => {
      try {
        const root = await ensureCrmRoot();
        setCrmRootId(root.id);
        if (activeTab === 'drive') {
          setFolderPath([DRIVE_ROOT]);
        } else {
          setFolderPath([{ id: root.id, name: root.name || CRM_ROOT_NAME }]);
        }
      } catch (err) {
        setItemsError(err.message || 'Could not open PugCRM.');
        if (activeTab === 'drive') setFolderPath([DRIVE_ROOT]);
      }
    })();
  }, [accessToken, activeTab, ensureCrmRoot]);

  const loadFolderContents = useCallback(async (folderId, opts = {}) => {
    const { silent = false } = opts;
    if (!folderId || !accessToken) return;
    if (!silent) setLoadingItems(true);
    setItemsError('');
    try {
      const params = new URLSearchParams({
        q: `'${folderId}' in parents and trashed = false`,
        fields: 'files(id, name, mimeType, webViewLink, createdTime, size)',
        orderBy: 'folder,name',
        pageSize: '200',
      });
      const res = await fetch(`https://www.googleapis.com/drive/v3/files?${params}`, {
        headers: { Authorization: `Bearer ${accessToken}` },
      });
      const data = await res.json();
      if (!res.ok) throw new Error(data.error?.message || 'Could not load this folder.');

      const all = data.files || [];
      setFolders(all.filter((f) => f.mimeType === FOLDER_MIME));
      setFiles(all.filter((f) => f.mimeType !== FOLDER_MIME));
    } catch (err) {
      if (!silent) setItemsError(err.message);
    } finally {
      if (!silent) setLoadingItems(false);
    }
  }, [accessToken]);

  useEffect(() => {
    if (currentFolder) loadFolderContents(currentFolder.id);
  }, [currentFolder, loadFolderContents]);

  useEffect(() => {
    if (!currentFolder) return undefined;
    const tick = () => loadFolderContents(currentFolder.id, { silent: true });
    const interval = setInterval(tick, 20000);
    const onVisible = () => {
      if (document.visibilityState === 'visible') tick();
    };
    window.addEventListener('focus', tick);
    document.addEventListener('visibilitychange', onVisible);
    return () => {
      clearInterval(interval);
      window.removeEventListener('focus', tick);
      document.removeEventListener('visibilitychange', onVisible);
    };
  }, [currentFolder, loadFolderContents]);

  const refresh = () => currentFolder && loadFolderContents(currentFolder.id);

  /* ---- navigation ---- */
  const openFolder = (folder) => setFolderPath((prev) => [...prev, { id: folder.id, name: folder.name }]);
  const goToBreadcrumb = (index) => setFolderPath((prev) => prev.slice(0, index + 1));

  /* ---- create a sub-folder inside the folder that's open ---- */
  const handleCreateFolder = async () => {
    if (!newFolderName.trim() || !currentFolder) return;
    setCreatingFolder(true);
    setItemsError('');
    try {
      const res = await fetch('https://www.googleapis.com/drive/v3/files', {
        method: 'POST',
        headers: { Authorization: `Bearer ${accessToken}`, 'Content-Type': 'application/json' },
        body: JSON.stringify({
          name: newFolderName.trim(),
          mimeType: FOLDER_MIME,
          parents: [currentFolder.id],
        }),
      });
      if (!res.ok) throw new Error('Could not create the folder.');
      setNewFolderName('');
      setShowNewFolderInput(false);
      loadFolderContents(currentFolder.id);
    } catch (err) {
      setItemsError(err.message);
    } finally {
      setCreatingFolder(false);
    }
  };

  /* ---- rename a file or folder (never the PugCRM root itself) ---- */
  const startRename = (item, isFolder) => {
    if (isFolder && item.id === crmRootId) return;
    setDeleteTarget(null);
    setRenamingId(item.id);
    setRenameValue(item.name);
  };

  const cancelRename = () => {
    setRenamingId(null);
    setRenameValue('');
  };

  const confirmRename = async (item) => {
    const trimmed = renameValue.trim();
    if (!trimmed || trimmed === item.name) {
      cancelRename();
      return;
    }
    setRenaming(true);
    setItemsError('');
    try {
      const res = await fetch(`https://www.googleapis.com/drive/v3/files/${item.id}`, {
        method: 'PATCH',
        headers: { Authorization: `Bearer ${accessToken}`, 'Content-Type': 'application/json' },
        body: JSON.stringify({ name: trimmed }),
      });
      if (!res.ok) {
        const data = await res.json().catch(() => ({}));
        throw new Error(data.error?.message || 'Could not rename this item.');
      }
      cancelRename();
      if (currentFolder) loadFolderContents(currentFolder.id, { silent: true });
    } catch (err) {
      setItemsError(err.message);
    } finally {
      setRenaming(false);
    }
  };
  const requestDelete = (item, isFolder) => {
    if (isFolder && item.id === crmRootId) return;
    cancelRename();
    setDeleteTarget({ id: item.id, name: item.name, isFolder });
  };

  const cancelDelete = () => setDeleteTarget(null);

  const confirmDelete = async () => {
    if (!deleteTarget) return;
    setDeleting(true);
    setItemsError('');
    try {
      const res = await fetch(`https://www.googleapis.com/drive/v3/files/${deleteTarget.id}`, {
        method: 'PATCH',
        headers: { Authorization: `Bearer ${accessToken}`, 'Content-Type': 'application/json' },
        body: JSON.stringify({ trashed: true }),
      });
      if (!res.ok) {
        const data = await res.json().catch(() => ({}));
        throw new Error(data.error?.message || 'Could not delete this item.');
      }
      setDeleteTarget(null);
      if (currentFolder) loadFolderContents(currentFolder.id, { silent: true });
    } catch (err) {
      setItemsError(err.message);
    } finally {
      setDeleting(false);
    }
  };

  /* ---- upload — always goes into the folder that's currently open ---- */
  const pickFile = (file) => {
    if (!file) return;
    setSelectedFile(file);
    setUploadError('');
  };

  const handleFileChange = (e) => pickFile(e.target.files?.[0]);

  const runUpload = async () => {
    if (!selectedFile || !currentFolder) return;
    setUploading(true);
    setUploadError('');
    try {
      const metadata = { name: selectedFile.name, parents: [currentFolder.id] };
      const form = new FormData();
      form.append('metadata', new Blob([JSON.stringify(metadata)], { type: 'application/json' }));
      form.append('file', selectedFile);

      const res = await fetch(
        'https://www.googleapis.com/upload/drive/v3/files?uploadType=multipart&fields=id,name,webViewLink,mimeType,createdTime',
        { method: 'POST', headers: { Authorization: `Bearer ${accessToken}` }, body: form }
      );
      const data = await res.json();
      if (!res.ok) throw new Error(data.error?.message || 'Upload failed.');

      setSelectedFile(null);
      if (fileInputRef.current) fileInputRef.current.value = '';
      loadFolderContents(currentFolder.id);
    } catch (err) {
      setUploadError(err.message);
    } finally {
      setUploading(false);
    }
  };

  /* ---- drag & drop over the whole content area ---- */
  const onDragEnter = (e) => { e.preventDefault(); dragCounter.current += 1; setIsDragging(true); };
  const onDragLeave = (e) => { e.preventDefault(); dragCounter.current -= 1; if (dragCounter.current <= 0) setIsDragging(false); };
  const onDragOver = (e) => e.preventDefault();
  const onDrop = (e) => {
    e.preventDefault();
    dragCounter.current = 0;
    setIsDragging(false);
    pickFile(e.dataTransfer.files?.[0]);
  };

  /* ---- download ---- */
  const handleDownload = async (fileId, fileName) => {
    try {
      const res = await fetch(`https://www.googleapis.com/drive/v3/files/${fileId}?alt=media`, {
        headers: { Authorization: `Bearer ${accessToken}` },
      });
      if (!res.ok) throw new Error('Download failed.');
      const blob = await res.blob();
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = fileName;
      document.body.appendChild(a);
      a.click();
      a.remove();
      window.URL.revokeObjectURL(url);
    } catch (err) {
      setItemsError(`Download failed: ${err.message}`);
    }
  };

  const handleDisconnect = () => {
    setActiveTab('crm');
    setSearchQuery('');
    setRenamingId(null);
    setRenameValue('');
    setDeleteTarget(null);
    disconnect();
  };

  /* ---- client-side filter of the open folder ---- */
  const filteredFolders = useMemo(
    () => folders.filter((f) => f.name.toLowerCase().includes(searchQuery.trim().toLowerCase())),
    [folders, searchQuery]
  );
  const filteredFiles = useMemo(
    () => files.filter((f) => f.name.toLowerCase().includes(searchQuery.trim().toLowerCase())),
    [files, searchQuery]
  );
  const isEmpty = !loadingItems && filteredFolders.length === 0 && filteredFiles.length === 0;
  const totalCount = folders.length + files.length;

  if (!accessToken) {
    return (
      <div className="dm-page dm-page-center">
        <GlobalStyles />
        <div className="dm-signin-card">
          <div className="dm-signin-icon"><Icon.Drive width={26} height={26} /></div>
          <h1 className="dm-signin-title">Document Manager</h1>
          <p className="dm-signin-copy">
            Connect Google Drive to store, organize and share every file linked to your deals and
            accounts — using the same login as Calendar.
          </p>
          {authError && <p className="dm-banner dm-banner-error">{authError}</p>}
          <button className="dm-btn dm-btn-primary dm-btn-lg" onClick={connect} disabled={!gisReady}>
            <Icon.Google />
            {gisReady ? 'Connect Google Drive' : 'Loading…'}
          </button>
        </div>
      </div>
    );
  }
  return (
    <div className="dm-page">
      <GlobalStyles />
      {/* Page header */}
      <header className="dm-page-header">
        <div>
          <h1 className="dm-page-title">Documents</h1>
          <p className="dm-page-subtitle">Files linked to your leads, deals and accounts</p>
        </div>
        <div className="dm-account">
          <span className="dm-account-dot" />
          <span className="dm-account-email">{userEmail || 'Connected'}</span>
          <button className="dm-link dm-link-danger" onClick={handleDisconnect}>Disconnect</button>
        </div>
      </header>
      <div className="dm-layout">
        {/* Sidebar */}
        <aside className="dm-sidebar">
          <nav className="dm-nav">
            {TABS.map((tab) => (
              <button
                key={tab.id}
                className={`dm-nav-item ${activeTab === tab.id ? 'dm-nav-item-active' : ''}`}
                onClick={() => setActiveTab(tab.id)}
              >
                {tab.id === 'crm' ? <Icon.Folder width={17} height={17} /> : <Icon.Drive width={17} height={17} />}
                <span>
                  <span className="dm-nav-item-label">{tab.label}</span>
                  <span className="dm-nav-item-hint">{tab.hint}</span>
                </span>
              </button>
            ))}
          </nav>

          <div className="dm-sidebar-divider" />

          <div className="dm-sidebar-label">Current location</div>
          <div className="dm-path-trail">
            {folderPath.map((f, i) => (
              <button
                key={f.id}
                className={`dm-path-item ${i === folderPath.length - 1 ? 'dm-path-item-current' : ''}`}
                onClick={() => goToBreadcrumb(i)}
                disabled={i === folderPath.length - 1}
                style={{ paddingLeft: 10 + i * 14 }}
              >
                {i === 0 ? <Icon.Home width={13} height={13} /> : <Icon.Chevron width={12} height={12} />}
                <span>{f.name}</span>
              </button>
            ))}
          </div>

          <div className="dm-sidebar-divider" />

          <div className="dm-sidebar-stats">
            <span>{totalCount} item{totalCount === 1 ? '' : 's'}</span>
            <button className="dm-icon-btn" onClick={refresh} title="Refresh" disabled={loadingItems}>
              <Icon.Refresh className={loadingItems ? 'dm-spin' : ''} width={15} height={15} />
            </button>
          </div>
        </aside>

        {/* Main content */}
        <main
          className="dm-main"
          onDragEnter={onDragEnter}
          onDragLeave={onDragLeave}
          onDragOver={onDragOver}
          onDrop={onDrop}
        >
          {isDragging && (
            <div className="dm-drop-overlay">
              <Icon.UploadCloud width={30} height={30} />
              <p>Drop to upload into “{currentFolder?.name}”</p>
            </div>
          )}

          {/* Toolbar */}
          <div className="dm-toolbar">
            <div className="dm-search">
              <Icon.Search width={16} height={16} />
              <input
                placeholder={`Search in "${currentFolder?.name || ''}"`}
                value={searchQuery}
                onChange={(e) => setSearchQuery(e.target.value)}
              />
            </div>

            <div className="dm-toolbar-actions">
              {showNewFolderInput ? (
                <div className="dm-new-folder">
                  <input
                    autoFocus
                    placeholder="Folder name"
                    value={newFolderName}
                    onChange={(e) => setNewFolderName(e.target.value)}
                    onKeyDown={(e) => e.key === 'Enter' && handleCreateFolder()}
                  />
                  <button className="dm-btn dm-btn-primary" onClick={handleCreateFolder} disabled={creatingFolder || !newFolderName.trim()}>
                    {creatingFolder ? '…' : 'Create'}
                  </button>
                  <button className="dm-icon-btn" onClick={() => { setShowNewFolderInput(false); setNewFolderName(''); }}>
                    <Icon.X width={16} height={16} />
                  </button>
                </div>
              ) : (
                <button className="dm-btn dm-btn-outline" onClick={() => setShowNewFolderInput(true)}>
                  <Icon.Plus width={16} height={16} />
                  New folder
                </button>
              )}

              <input ref={fileInputRef} type="file" onChange={handleFileChange} hidden />
              <button className="dm-btn dm-btn-primary" onClick={() => fileInputRef.current?.click()}>
                <Icon.Upload width={16} height={16} />
                Upload
              </button>
            </div>
          </div>

          {itemsError && <p className="dm-banner dm-banner-error">{itemsError}</p>}
          {uploadError && <p className="dm-banner dm-banner-error">{uploadError}</p>}

          {selectedFile && (
            <div className="dm-pending-upload">
              <FileTypeIcon mimeType={selectedFile.type} size={16} />
              <div className="dm-row-main">
                <span className="dm-row-name">{selectedFile.name}</span>
                <span className="dm-row-meta">Uploads into “{currentFolder?.name || '…'}” · {formatBytes(selectedFile.size)}</span>
              </div>
              <button className="dm-btn dm-btn-primary" onClick={runUpload} disabled={uploading}>
                {uploading ? 'Uploading…' : 'Upload'}
              </button>
              <button
                className="dm-icon-btn"
                onClick={() => { setSelectedFile(null); if (fileInputRef.current) fileInputRef.current.value = ''; }}
              >
                <Icon.X width={16} height={16} />
              </button>
            </div>
          )}

          {/* Listing */}
          {loadingItems && (
            <div className="dm-empty-state">
              <div className="dm-spinner" />
              <p>Loading…</p>
            </div>
          )}

          {isEmpty && (
            <div className="dm-empty-state">
              <Icon.Folder width={30} height={30} />
              <p>{searchQuery ? 'No matches in this folder.' : 'This folder is empty.'}</p>
              {!searchQuery && (
                <p className="dm-empty-hint">Drag a file anywhere on this page, or use Upload above.</p>
              )}
            </div>
          )}

          {!loadingItems && (filteredFolders.length > 0 || filteredFiles.length > 0) && (
            <div className="dm-grid">
              {filteredFolders.map((f) => {
                const isRoot = f.id === crmRootId;
                const isRenaming = renamingId === f.id;
                return (
                  <div key={f.id} className="dm-card dm-card-folder">
                    <div
                      className="dm-card-clickable"
                      role="button"
                      tabIndex={isRenaming ? -1 : 0}
                      onClick={() => !isRenaming && openFolder(f)}
                      onKeyDown={(e) => {
                        if (!isRenaming && (e.key === 'Enter' || e.key === ' ')) openFolder(f);
                      }}
                    >
                      <FileTypeIcon mimeType={f.mimeType} />
                      {isRenaming ? (
                        <input
                          autoFocus
                          className="dm-rename-input"
                          value={renameValue}
                          onClick={(e) => e.stopPropagation()}
                          onChange={(e) => setRenameValue(e.target.value)}
                          onKeyDown={(e) => {
                            e.stopPropagation();
                            if (e.key === 'Enter') confirmRename(f);
                            if (e.key === 'Escape') cancelRename();
                          }}
                        />
                      ) : (
                        <span className="dm-card-name">{f.name}</span>
                      )}
                      {!isRenaming && <Icon.Chevron width={15} height={15} className="dm-card-chevron" />}
                    </div>
                    {!isRoot && (
                      <div className="dm-card-actions">
                        {isRenaming ? (
                          <>
                            <button className="dm-icon-btn" onClick={() => confirmRename(f)} disabled={renaming} title="Save name">
                              <Icon.Check width={14} height={14} />
                            </button>
                            <button className="dm-icon-btn" onClick={cancelRename} title="Cancel">
                              <Icon.X width={14} height={14} />
                            </button>
                          </>
                        ) : (
                          <>
                            <button className="dm-icon-btn" onClick={() => startRename(f, true)} title="Rename folder">
                              <Icon.Edit width={14} height={14} />
                            </button>
                            <button className="dm-icon-btn dm-icon-btn-danger" onClick={() => requestDelete(f, true)} title="Delete folder">
                              <Icon.Trash width={14} height={14} />
                            </button>
                          </>
                        )}
                      </div>
                    )}
                  </div>
                );
              })}
              {filteredFiles.map((f) => {
                const isRenaming = renamingId === f.id;
                return (
                  <div key={f.id} className="dm-card">
                    <FileTypeIcon mimeType={f.mimeType} />
                    {isRenaming ? (
                      <input
                        autoFocus
                        className="dm-rename-input"
                        value={renameValue}
                        onChange={(e) => setRenameValue(e.target.value)}
                        onKeyDown={(e) => {
                          if (e.key === 'Enter') confirmRename(f);
                          if (e.key === 'Escape') cancelRename();
                        }}
                      />
                    ) : (
                      <>
                        <span className="dm-card-name">{f.name}</span>
                        <span className="dm-card-meta">{formatBytes(f.size)} · {formatDate(f.createdTime)}</span>
                      </>
                    )}
                    <div className="dm-card-actions">
                      {isRenaming ? (
                        <>
                          <button className="dm-icon-btn" onClick={() => confirmRename(f)} disabled={renaming} title="Save name">
                            <Icon.Check width={15} height={15} />
                          </button>
                          <button className="dm-icon-btn" onClick={cancelRename} title="Cancel">
                            <Icon.X width={15} height={15} />
                          </button>
                        </>
                      ) : (
                        <>
                          <a href={f.webViewLink} target="_blank" rel="noopener noreferrer" className="dm-icon-btn" title="Preview">
                            <Icon.ExternalLink width={15} height={15} />
                          </a>
                          <button className="dm-icon-btn" onClick={() => handleDownload(f.id, f.name)} title="Download">
                            <Icon.Download width={15} height={15} />
                          </button>
                          <button className="dm-icon-btn" onClick={() => startRename(f, false)} title="Rename file">
                            <Icon.Edit width={15} height={15} />
                          </button>
                          <button className="dm-icon-btn dm-icon-btn-danger" onClick={() => requestDelete(f, false)} title="Delete file">
                            <Icon.Trash width={15} height={15} />
                          </button>
                        </>
                      )}
                    </div>
                  </div>
                );
              })}
            </div>
          )}
        </main>
      </div>

      {deleteTarget && (
        <div className="dm-modal-overlay" onClick={cancelDelete}>
          <div className="dm-modal" onClick={(e) => e.stopPropagation()}>
            <h3 className="dm-modal-title">Delete {deleteTarget.isFolder ? 'folder' : 'file'}?</h3>
            <p className="dm-modal-copy">
              “{deleteTarget.name}”{deleteTarget.isFolder ? ' and everything inside it' : ''} will be moved to your Google Drive trash.
            </p>
            <div className="dm-modal-actions">
              <button className="dm-btn dm-btn-outline" onClick={cancelDelete} disabled={deleting}>
                Cancel
              </button>
              <button className="dm-btn dm-btn-danger" onClick={confirmDelete} disabled={deleting}>
                {deleting ? 'Deleting…' : 'Delete'}
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};


const GlobalStyles = () => (
  <style>{`
    .dm-page {
      --dm-navy: #16233F;
      --dm-navy-soft: #2C3B5C;
      --dm-slate: #5B6478;
      --dm-slate-light: #8890A0;
      --dm-bg: #F6F7F9;
      --dm-surface: #FFFFFF;
      --dm-border: #E4E7EC;
      --dm-primary: #1E3A5F;
      --dm-primary-hover: #142845;
      --dm-primary-soft: #EAF0F8;
      --dm-gold: #A9761F;
      --dm-gold-soft: #F7EFDE;
      --dm-success: #1F9D6B;
      --dm-danger: #C4432E;
      --dm-danger-soft: #FBEAE6;
      --dm-radius: 12px;
      --dm-radius-sm: 8px;
      font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;
      color: var(--dm-navy);
      width: 100%;
      min-height: 100%;
      box-sizing: border-box;
      background: var(--dm-bg);
      padding: 28px 36px 48px;
    }
    .dm-page * { box-sizing: border-box; }

    .dm-page-center { display: flex; align-items: center; justify-content: center; min-height: 100vh; }

    /* ---- sign-in state ---- */
    .dm-signin-card {
      text-align: center; padding: 44px 34px; max-width: 400px;
      background: var(--dm-surface); border: 1px solid var(--dm-border);
      border-radius: var(--dm-radius); box-shadow: 0 1px 2px rgba(22,35,63,0.05);
    }
    .dm-signin-icon {
      width: 52px; height: 52px; border-radius: 12px;
      background: var(--dm-primary-soft); color: var(--dm-primary);
      display: flex; align-items: center; justify-content: center;
      margin: 0 auto 16px;
    }
    .dm-signin-title {
      font-family: 'Source Serif 4', Georgia, serif;
      font-size: 22px; font-weight: 600; margin: 0 0 8px;
    }
    .dm-signin-copy {
      color: var(--dm-slate); font-size: 14px; line-height: 1.6;
      max-width: 360px; margin: 0 auto 22px;
    }

    /* ---- page header ---- */
    .dm-page-header { display: flex; justify-content: space-between; align-items: flex-start; gap: 12px; flex-wrap: wrap; margin-bottom: 24px; }
    .dm-page-title { font-family: 'Source Serif 4', Georgia, serif; font-size: 26px; font-weight: 600; margin: 0; }
    .dm-page-subtitle { font-size: 13.5px; color: var(--dm-slate); margin: 4px 0 0; }
    .dm-account { display: flex; align-items: center; gap: 8px; font-size: 13px; color: var(--dm-slate); margin-top: 4px; }
    .dm-account-dot { width: 7px; height: 7px; border-radius: 50%; background: var(--dm-success); }
    .dm-account-email { color: var(--dm-navy); font-weight: 500; }

    .dm-link { background: none; border: none; cursor: pointer; padding: 0; font-size: 13px; font-family: inherit; }
    .dm-link-danger { color: var(--dm-danger); }
    .dm-link-danger:hover { text-decoration: underline; }

    /* ---- layout ---- */
    .dm-layout { display: grid; grid-template-columns: 240px 1fr; gap: 24px; align-items: start; }

    /* ---- sidebar ---- */
    .dm-sidebar {
      background: var(--dm-surface); border: 1px solid var(--dm-border); border-radius: var(--dm-radius);
      padding: 14px; position: sticky; top: 20px;
    }
    .dm-nav { display: flex; flex-direction: column; gap: 3px; }
    .dm-nav-item {
      display: flex; align-items: center; gap: 10px; text-align: left;
      background: none; border: none; cursor: pointer; border-radius: var(--dm-radius-sm);
      padding: 9px 10px; color: var(--dm-slate); font-family: inherit;
    }
    .dm-nav-item:hover { background: var(--dm-bg); color: var(--dm-navy); }
    .dm-nav-item-active { background: var(--dm-primary-soft); color: var(--dm-primary); }
    .dm-nav-item-label { display: block; font-size: 13.5px; font-weight: 600; }
    .dm-nav-item-hint { display: block; font-size: 11.5px; opacity: 0.75; margin-top: 1px; }

    .dm-sidebar-divider { height: 1px; background: var(--dm-border); margin: 12px 0; }
    .dm-sidebar-label { font-size: 11px; font-weight: 600; text-transform: uppercase; letter-spacing: 0.04em; color: var(--dm-slate-light); padding: 0 10px 6px; }
    .dm-path-trail { display: flex; flex-direction: column; gap: 1px; max-height: 220px; overflow-y: auto; }
    .dm-path-item {
      display: flex; align-items: center; gap: 6px; text-align: left;
      background: none; border: none; cursor: pointer; border-radius: 6px;
      padding: 6px 10px; font-size: 12.5px; color: var(--dm-primary); font-family: inherit;
    }
    .dm-path-item span { overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }
    .dm-path-item:hover:not(:disabled) { background: var(--dm-bg); }
    .dm-path-item-current { color: var(--dm-navy); font-weight: 600; cursor: default; }

    .dm-sidebar-stats { display: flex; align-items: center; justify-content: space-between; padding: 0 6px; font-size: 12px; color: var(--dm-slate-light); }

    /* ---- main ---- */
    .dm-main { position: relative; min-width: 0; }

    .dm-drop-overlay {
      position: absolute; inset: 0; z-index: 5;
      display: flex; flex-direction: column; align-items: center; justify-content: center; gap: 10px;
      background: rgba(234,240,248,0.94); border: 2px dashed var(--dm-primary); border-radius: var(--dm-radius);
      color: var(--dm-primary); font-size: 14px; font-weight: 500;
    }

    .dm-toolbar { display: flex; gap: 10px; flex-wrap: wrap; margin-bottom: 14px; }
    .dm-search {
      flex: 1; min-width: 200px; display: flex; align-items: center; gap: 8px;
      border: 1px solid var(--dm-border); border-radius: var(--dm-radius-sm);
      padding: 9px 12px; background: var(--dm-surface); color: var(--dm-slate-light);
    }
    .dm-search input { border: none; background: none; outline: none; font-size: 13.5px; color: var(--dm-navy); width: 100%; font-family: inherit; }
    .dm-toolbar-actions { display: flex; gap: 8px; flex-wrap: wrap; }
    .dm-new-folder { display: flex; gap: 6px; align-items: center; }
    .dm-new-folder input {
      border: 1px solid var(--dm-border); border-radius: var(--dm-radius-sm);
      padding: 9px 12px; font-size: 13.5px; outline: none; font-family: inherit; width: 160px;
    }
    .dm-new-folder input:focus { border-color: var(--dm-primary); }

    /* ---- buttons ---- */
    .dm-btn {
      display: inline-flex; align-items: center; gap: 6px; justify-content: center;
      font-size: 13.5px; font-weight: 500; font-family: inherit;
      border-radius: var(--dm-radius-sm); padding: 9px 15px;
      border: 1px solid transparent; cursor: pointer; transition: background .15s ease, border-color .15s ease;
      white-space: nowrap;
    }
    .dm-btn:disabled { opacity: .55; cursor: not-allowed; }
    .dm-btn-primary { background: var(--dm-primary); color: #fff; }
    .dm-btn-primary:hover:not(:disabled) { background: var(--dm-primary-hover); }
    .dm-btn-outline { background: var(--dm-surface); color: var(--dm-navy); border-color: var(--dm-border); }
    .dm-btn-outline:hover:not(:disabled) { border-color: var(--dm-primary); color: var(--dm-primary); }
    .dm-btn-danger { background: var(--dm-danger); color: #fff; }
    .dm-btn-danger:hover:not(:disabled) { background: #A6371F; }
    .dm-btn-lg { padding: 11px 22px; font-size: 14px; }

    .dm-icon-btn {
      display: inline-flex; align-items: center; justify-content: center;
      width: 30px; height: 30px; border-radius: var(--dm-radius-sm);
      background: none; border: 1px solid transparent; color: var(--dm-slate);
      cursor: pointer; flex-shrink: 0; text-decoration: none;
    }
    .dm-icon-btn:hover { background: var(--dm-bg); color: var(--dm-navy); }
    .dm-icon-btn-danger:hover { background: var(--dm-danger-soft); color: var(--dm-danger); }

    /* ---- banners ---- */
    .dm-banner { font-size: 13px; padding: 9px 12px; border-radius: var(--dm-radius-sm); margin: 0 0 12px; }
    .dm-banner-error { background: var(--dm-danger-soft); color: var(--dm-danger); }

    /* ---- pending upload bar ---- */
    .dm-pending-upload {
      display: flex; align-items: center; gap: 12px;
      border: 1px solid var(--dm-border); background: var(--dm-surface);
      border-radius: var(--dm-radius); padding: 10px 12px; margin-bottom: 16px;
    }

    /* ---- type icon ---- */
    .dm-type-icon {
      display: inline-flex; align-items: center; justify-content: center;
      width: 36px; height: 36px; border-radius: 8px; flex-shrink: 0;
    }

    /* ---- grid of cards ---- */
    .dm-grid {
      display: grid; grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));
      gap: 10px;
    }
    .dm-card {
      position: relative; display: flex; flex-direction: column; gap: 8px;
      background: var(--dm-surface); border: 1px solid var(--dm-border); border-radius: var(--dm-radius);
      padding: 14px; text-align: left; font-family: inherit; cursor: default;
      transition: border-color .12s ease, box-shadow .12s ease;
    }
    .dm-card:hover { border-color: #D3D8E1; box-shadow: 0 2px 8px rgba(22,35,63,0.06); }
    .dm-card-folder { cursor: default; }
    .dm-card-clickable {
      display: flex; flex-direction: column; gap: 8px; width: 100%;
      text-align: left; cursor: pointer; outline: none;
    }
    .dm-card-clickable:focus-visible { box-shadow: 0 0 0 2px var(--dm-primary-soft), 0 0 0 3px var(--dm-primary); border-radius: 6px; }
    .dm-card-name { font-size: 13.5px; font-weight: 500; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }
    .dm-card-meta { font-size: 12px; color: var(--dm-slate-light); margin-top: -4px; }
    .dm-card-chevron { position: absolute; top: 14px; right: 12px; color: var(--dm-slate-light); }
    .dm-card-actions { display: flex; gap: 4px; margin-top: 2px; }
    .dm-rename-input {
      border: 1px solid var(--dm-primary); border-radius: 6px; outline: none;
      padding: 5px 7px; font-size: 13.5px; font-family: inherit; width: 100%;
      color: var(--dm-navy); background: var(--dm-surface);
    }

    /* ---- delete confirmation modal ---- */
    .dm-modal-overlay {
      position: fixed; inset: 0; z-index: 50; display: flex; align-items: center; justify-content: center;
      background: rgba(22,35,63,0.35); padding: 16px;
    }
    .dm-modal {
      background: var(--dm-surface); border-radius: var(--dm-radius); padding: 22px;
      max-width: 360px; width: 100%; box-shadow: 0 12px 32px rgba(22,35,63,0.18);
    }
    .dm-modal-title { font-size: 16px; font-weight: 600; margin: 0 0 8px; color: var(--dm-navy); }
    .dm-modal-copy { font-size: 13.5px; color: var(--dm-slate); line-height: 1.5; margin: 0 0 18px; }
    .dm-modal-actions { display: flex; justify-content: flex-end; gap: 8px; }

    .dm-row-main { display: flex; flex-direction: column; min-width: 0; flex: 1; gap: 1px; }
    .dm-row-name { font-size: 13.5px; font-weight: 500; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }
    .dm-row-meta { font-size: 12px; color: var(--dm-slate-light); }

    /* ---- empty / loading ---- */
    .dm-empty-state {
      display: flex; flex-direction: column; align-items: center; gap: 8px;
      padding: 64px 0; color: var(--dm-slate-light); font-size: 13.5px;
      background: var(--dm-surface); border: 1px dashed var(--dm-border); border-radius: var(--dm-radius);
    }
    .dm-empty-hint { font-size: 12px; }
    .dm-spinner {
      width: 20px; height: 20px; border-radius: 50%;
      border: 2px solid var(--dm-border); border-top-color: var(--dm-primary);
      animation: dm-rotate .7s linear infinite;
    }
    .dm-spin { animation: dm-rotate .7s linear infinite; }
    @keyframes dm-rotate { to { transform: rotate(360deg); } }

    @media (max-width: 860px) {
      .dm-layout { grid-template-columns: 1fr; }
      .dm-sidebar { position: static; }
      .dm-path-trail { max-height: none; }
    }
    @media (max-width: 520px) {
      .dm-page { padding: 20px 16px 36px; }
      .dm-toolbar { flex-direction: column; align-items: stretch; }
      .dm-new-folder input { width: auto; flex: 1; }
    }
  `}</style>
);

export default DocumentManager;